import React, { useMemo } from 'react';
import { upperFirst } from 'lodash';
import { Breadcrumbs, Crumb } from 'components/core/Breadcrumbs';
import { cleanTitle } from 'utils/title';
import { PAGE_SUB_TYPES } from '@sparefoot/tracking-events';

export const enhance = (Component) => (props) => {
	const { location, searchParams, canonicalUrl, baseUrl, isNewSearchPage, primaryHeadline, nearMeKeyword, isNearMePage, ...rest } = props;

	const computedProps = useMemo(() => {
		const { streetAddress, zip } = location;
		const {
			amenity, latitude, longitude, vehicle, neighborhood, subPageType
		} = searchParams;
		const crumbs = [];

		if (isNearMePage || subPageType === 'nearMePages') {
			if (!nearMeKeyword) {
				return { crumbs: [], baseUrl, isNewSearchPage, stateUrl: '', cityUrl: '' };
			}
			const nearMeLabel = primaryHeadline || 'Storage Near You';
			const nearMeUrl = `${(baseUrl || '').replace(/\/$/, '')}/near-me/${nearMeKeyword}.html`;
			crumbs.push(
				<Crumb
					key="near-me"
					href={nearMeUrl}
					isLast
					label={nearMeLabel}
					name={nearMeLabel}
				/>
			);
			return { crumbs, baseUrl, isNewSearchPage, stateUrl: '', cityUrl: '' };
		} else if (subPageType === PAGE_SUB_TYPES.NEIGHBORHOOD_LANDING && neighborhood) {
			crumbs.push(
				<Crumb
					key="neighborhood"
					href={canonicalUrl}
					isLast
					label={cleanTitle(neighborhood)}
				/>
			);
		} else if (subPageType === PAGE_SUB_TYPES.AMENITY_LANDING) {
			crumbs.push(
				<Crumb
					key="amenity"
					href={canonicalUrl}
					isLast
					label={cleanTitle(amenity)}
				/>
			);
		} else if (subPageType === PAGE_SUB_TYPES.VEHICLE_LANDING) {
			crumbs.push(
				<Crumb
					key="vehicle"
					href={canonicalUrl}
					isLast
					label={vehicle === 'rv' ? 'RV' : `${upperFirst(vehicle)} storage`}
				/>
			);
		} else if (subPageType === PAGE_SUB_TYPES.ZIP_LANDING) {
			crumbs.push(
				<Crumb
					key="zip"
					href={canonicalUrl}
					isLast
					label={zip}
				/>
			);
		} else if (streetAddress && !(latitude || longitude)) {
			crumbs.push(
				<Crumb
					key="streetAddress"
					href={canonicalUrl}
					isLast
					label={streetAddress}
				/>
			);
		}


		return ({ crumbs, baseUrl, isNewSearchPage });
	}, [location, searchParams, baseUrl, nearMeKeyword, isNearMePage, canonicalUrl, isNewSearchPage, primaryHeadline]);

	return <Component {...rest} location={location} {...computedProps} />;
};

export default enhance(Breadcrumbs);
